import * as LDClient from 'launchdarkly-js-client-sdk'
import { isVue3, loadVue } from './utils'
import { initialize } from '../core'
import { setFeatureFlags, setReactiveStore } from '../featureFlags'

function initializedReactiveStore() {
  const vue = loadVue()
  if (isVue3(vue)) {
    setReactiveStore(vue.reactive({ data: {} }))
  } else {
    setReactiveStore(vue.observable({ data: {} }))
  }
}

initializedReactiveStore()

async function initializeVue(
  key: string,
  context: LDClient.LDContext,
  options?: LDClient.LDOptions
) {
  const client = await initialize(key, context, options)

  setFeatureFlags(client.allFlags())

  client.on('change', () => {
    setFeatureFlags(client.allFlags())
  })
}

export { initializeVue }
